<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: keyof typeof variantMapping
  }>(),
  {
    variant: 'default'
  }
)

const variantMapping = {
  default: 'px-5 sm:px-6 py-4',
  mini: 'px-[30px] py-5'
}
</script>

<template>
  <footer
    class="border-t border-t-slate-tint-3 rounded-b-[15px]"
    :class="variantMapping[variant]"
  >
    <slot name="additional-content"></slot>
    <div class="flex justify-between items-center gap-5">
      <div class="w-full">
        <slot name="left-content"></slot>
      </div>
      <div class="flex space-x-2 items-center">
        <slot></slot>
      </div>
    </div>
  </footer>
</template>
